import constantes from '../resources/constantes.json';
const getParents = (id, eleccion, nomenclator, parentLevel) => {
  const elec = String(eleccion);
  let ambito = nomenclator.ambitos[elec][id];
  //TODO: El nomenclator nos da como padre un array.
  //Cuando haya más de un padre habra que implementar más lógica aquí
  const parents = [];
  if (id.length > 11) return parents;
  let parentType = 0;
  /* switch (window.zonaOComuna) {
    case constantes.level.zona:
      // TODO: ver cual es el orden de los padres en el nomenclator cuando se metan
      parentType = 0;
      break;
    case constantes.level.comuna:
      // TODO: ver cual es el orden de los padres en el nomenclator cuando se metan
      parentType = 1;
      break;
    default:
      break;
  } */
  if (
    window.zonaOComuna &&
    ambito.l === constantes.level.puesto &&
    elec !== constantes.eleccion.jal
  )
    parentType = window.zonaOComuna;
  else parentType = 0;
  ambito = nomenclator.ambitos[eleccion][ambito.p && ambito.p[parentType]];

  while (ambito != null) {
    parents.push(ambito.i);
    if (
      window.zonaOComuna &&
      ambito.l === constantes.level.puesto &&
      elec !== constantes.eleccion.jal
    )
      parentType = window.zonaOComuna;
    else parentType = 0;
    ambito = nomenclator.ambitos[eleccion][ambito.p && ambito.p[parentType]];
  }
  return parents;
};

export default getParents;
